import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import BanksFloorConfigurationTable from "./BanksFloorConfigurationTable";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const BanksFloorConfigurationPage = () => {
	// ************************************************ */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("permission-not-defined", permissions) ? (
				<div className={`layout__contentPage__${theme}`}>
					<BanksFloorConfigurationTable />
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
};

export default BanksFloorConfigurationPage;
